import styled from "styled-components";
import { TagStatus } from "../types";

type StatusTagProps = {
  status?: TagStatus;
};

const StatusTag = styled.div<StatusTagProps>`
  display: inline-block;
  font-size: 12px;
  text-transform: capitalize;
  border-radius: 3px;
  padding: 5px 8px 4px;
  font-weight: bold;
  white-space: nowrap;

  color: ${({ theme }) => theme.colors.white};

  color: ${({ theme, status }) => {
    switch (status) {
      case "success":
        return theme.colors.success;
      case "error":
        return theme.colors.error;
      case "warning":
        return theme.colors.warning;
      case "info":
        return theme.colors.info;
      case "default":
      default:
        return theme.colors.gray600;
    }
  }};
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme, status }) => {
    switch (status) {
      case "success":
        return theme.colors.success;
      case "error":
        return theme.colors.error;
      case "warning":
        return theme.colors.warning;
      case "info":
        return theme.colors.info;
      case "default":
      default:
        return theme.colors.gray600;
    }
  }};
  background-color: ${({ theme, status }) => {
    switch (status) {
      case "success":
        return theme.colors.successLight;
      case "error":
        return theme.colors.errorLight;
      case "warning":
        return theme.colors.warningLight;
      case "info":
        return theme.colors.infoLight;
      case "default":
      default:
        return theme.colors.gray100;
    }
  }};
`;

export default StatusTag;
